import { apiClient } from '../utils/apiClient';

export const HistoryService = {
  async getAcademicHistory(accessToken) {
    const token = accessToken || localStorage.getItem('llap_access_token') || localStorage.getItem('llap_auth_token');
    if (!token) {
      return { success: true, history: [] };
    }

    try {
      const response = await apiClient.get('/.netlify/functions/academic-history', {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response && response.success) {
        return response;
      }
      return { success: true, history: [] };
    } catch (error) {
      console.warn('HistoryService error (falling back to local history storage):', error.message);
      const localHistory = JSON.parse(localStorage.getItem('llap_academic_history') || '[]');
      return { success: true, history: localHistory };
    }
  }
};

export default HistoryService;